import { atom } from 'jotai';

export const isAuthModalOpenAtom = atom<boolean>(false);
export const isReportModalOpenAtom = atom<boolean>(false);
export const isMenuOpenAtom = atom<boolean>(false);
export const currentViewAtom = atom<'map' | 'list'>('map');
export const selectedMediaAtom = atom<{ type: string; url: string } | null>(null);

// Toast state
export const toastAtom = atom<{
  title?: string;
  description?: string;
  type?: 'success' | 'error' | 'info';
  duration?: number;
} | null>(null);